import React, { useContext, useState } from 'react';
import { AuthContext } from '../context/AuthContext';
import { authAPI } from '../api/auth';
import toast from 'react-hot-toast';

const Profile = () => {
  const { user, setUser } = useContext(AuthContext);
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    full_name: user?.full_name || '',
    phone_number: user?.phone_number || '',
    email: user?.email || '',
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const updatedUser = await authAPI.updateProfile(formData);
      setUser(updatedUser);
      localStorage.setItem('user', JSON.stringify(updatedUser));
      toast.success('Profile updated');
      setIsEditing(false);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Update failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto px-6 lg:px-8 py-12 lg:py-16">
      <div className="text-center mb-8">
        <h1 className="text-xl lg:text-2xl font-light tracking-tight text-gray-900">
          Profile
        </h1>
        <div className="w-12 h-px bg-gray-300 mx-auto mt-3"></div>
      </div>

      <div className="bg-white">
        {!isEditing ? (
          <div className="space-y-5">
            <div className="pb-3">
              <p className="text-xs text-gray-400 uppercase tracking-wider mb-1">
                Full Name
              </p>
              <p className="text-sm text-gray-900">
                {user?.full_name || '—'}
              </p>
            </div>
            
            <div className="pb-3">
              <p className="text-xs text-gray-400 uppercase tracking-wider mb-1">
                Email
              </p>
              <p className="text-sm text-gray-900">
                {user?.email || '—'}
              </p>
            </div>
            
            <div className="pb-3">
              <p className="text-xs text-gray-400 uppercase tracking-wider mb-1">
                Phone Number
              </p>
              <p className="text-sm text-gray-900">
                {user?.phone_number || '—'}
              </p>
            </div>
            
            <div className="pb-3">
              <p className="text-xs text-gray-400 uppercase tracking-wider mb-1">
                Gender
              </p>
              <p className="text-sm text-gray-900">
                {user?.gender || '—'}
              </p>
            </div>
            
            <div className="pt-4">
              <button
                onClick={() => setIsEditing(true)}
                className="text-sm text-gray-900 border-b border-gray-300 hover:border-gray-900 transition pb-0.5"
              >
                Edit Profile
              </button>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label htmlFor="full_name" className="block text-xs text-gray-400 uppercase tracking-wider mb-2">
                Full Name
              </label>
              <input
                id="full_name"
                name="full_name"
                type="text"
                value={formData.full_name}
                onChange={handleChange}
                required
                className="w-full px-0 py-2 text-sm text-gray-900 border-b border-gray-200 focus:outline-none focus:border-gray-900 transition bg-transparent"
              />
            </div>
            
            <div>
              <label htmlFor="email" className="block text-xs text-gray-400 uppercase tracking-wider mb-2">
                Email
              </label>
              <input
                id="email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                required
                disabled
                className="w-full px-0 py-2 text-sm text-gray-400 border-b border-gray-200 bg-transparent cursor-not-allowed"
              />
              <p className="text-[10px] text-gray-400 mt-1">Email cannot be changed</p>
            </div>
            
            <div>
              <label htmlFor="phone_number" className="block text-xs text-gray-400 uppercase tracking-wider mb-2">
                Phone Number
              </label>
              <input
                id="phone_number"
                name="phone_number"
                type="tel"
                value={formData.phone_number}
                onChange={handleChange}
                required
                className="w-full px-0 py-2 text-sm text-gray-900 border-b border-gray-200 focus:outline-none focus:border-gray-900 transition bg-transparent"
              />
            </div>
            
            <div className="flex gap-4 pt-4">
              <button
                type="submit"
                disabled={loading}
                className="text-sm text-gray-900 border-b border-gray-300 hover:border-gray-900 transition pb-0.5 disabled:opacity-50"
              >
                {loading ? 'Saving...' : 'Save Changes'}
              </button>
              <button
                type="button"
                onClick={() => setIsEditing(false)}
                className="text-sm text-gray-400 border-b border-transparent hover:border-gray-400 transition pb-0.5"
              >
                Cancel
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default Profile;